import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTenantInvoiceDetails = (token, id) => {
    return fetch(`${apiUrl}tenant_invoice_details/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenantInvoiceDetails